import { networkApi } from '../infrastructure/api/NetworkApiClient';
import {
  CustomLoadProfile,
  LoadProfileIdentifier,
  CreateProfileRequest,
  UpdateProfileRequest,
  LoadProfileValues
} from '../types/loadProfiles';

// Load profiles are GLOBAL system settings (no zone_id in the DB) — plain
// /api/settings/... paths, deliberately NOT zone-prefixed. The old zone-scoped
// route silently ignored the zone and was removed 2026-08.
export const loadProfileService = {
  async getAllProfiles(): Promise<LoadProfileIdentifier[]> {
    return networkApi.httpGet<LoadProfileIdentifier[]>('/settings/loadprofiles/all');
  },

  async getCustomProfiles(): Promise<CustomLoadProfile[]> {
    return networkApi.httpGet<CustomLoadProfile[]>('/settings/loadprofiles/custom');
  },

  async getCustomProfile(id: string): Promise<CustomLoadProfile> {
    return networkApi.httpGet<CustomLoadProfile>(`/settings/loadprofiles/custom/${id}`);
  },

  async createProfile(request: CreateProfileRequest): Promise<CustomLoadProfile> {
    return networkApi.httpPost<CustomLoadProfile>('/settings/loadprofiles/custom', request);
  },

  async updateProfile(id: string, request: UpdateProfileRequest): Promise<CustomLoadProfile> {
    return networkApi.httpPut<CustomLoadProfile>(`/settings/loadprofiles/custom/${id}`, request);
  },

  async deleteProfile(id: string): Promise<void> {
    return networkApi.httpDelete(`/settings/loadprofiles/custom/${id}`);
  },

  async duplicateProfile(id: string, newName: string, description?: string): Promise<CustomLoadProfile> {
    return networkApi.httpPost<CustomLoadProfile>(`/settings/loadprofiles/custom/${id}/duplicate`, { newName, description });
  },

  async getProfileValues(profileCode: string): Promise<LoadProfileValues> {
    // Use different endpoint for custom profiles
    const endpoint = profileCode.startsWith('CUSTOM_')
      ? `/settings/loadprofiles/custom/${profileCode}/values`
      : `/settings/loadprofiles/${profileCode}/values`;

    return networkApi.httpGet<LoadProfileValues>(endpoint);
  },
};
